export const getMails = (state) => state.mails
export const getUserContacts = (state) => state.user_contacts
export const getPriorities = (state) => state.priorities
export const getSignatures = (state) => state.signatures
export const getActiveSignature = (state) => state.active_signature
export const getScheduleMails = (state) => state.schedule_mails
export const getUnseenMailCount = (state) => state.unseenMailCount
export const getCurrentMail = (state) => state.currentMail
export const getImapConfig = (state) => state.imapConfig